module.exports = __webpack_public_path__ + "static/media/verhaltensbasiert_step_3_neg.9f4905f6.png";